import { getConfig } from '@cian/config/browser';

let ymapsPromise: Promise<YMaps.IYMaps>;

export function loadYmapsApi(options: YMaps.IReadyOptions): Promise<YMaps.IYMaps> {
  if (!ymapsPromise) {
    ymapsPromise = new Promise<YMaps.IYMaps>((resolve, reject) => {
      if (window.ymaps) {
        resolve(window.ymaps);

        return;
      }

      const config = getConfig();
      const apikey = config.getStrict<string>('commercial.MapApiKey');
      const suggest_apikey = config.getStrict<string>('commercial.SuggestApiKey');

      const e = window.document.createElement('script');

      const urlSearchParams = new URLSearchParams([
        ['apikey', apikey],
        ['suggest_apikey', suggest_apikey],
        ['lang', 'ru-RU'],
        ['load', 'package.system'],
        ['coordorder', 'longlat'],
      ]);

      e.src = `https://enterprise.api-maps.yandex.ru/2.1/?${urlSearchParams.toString()}`;
      e.async = true;
      e.defer = true;
      e.onload = () => {
        resolve(window.ymaps);
      };
      e.onerror = () => {
        reject(new Error('Unable to load Yandex Maps API'));
      };
      window.document.body.appendChild(e);
    });
  }

  return ymapsPromise.then(ymaps => ymaps.ready(options).then(() => ymaps));
}
